
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService,
              private router: Router, ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = request.clone({
      setHeaders: {
        Authorization: `${this.auth.getTokenBackEnd()}`, 
        urlOrigin: `${this.router.url}`
      }
    });

    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse)
        {
          if (this.auth.getTokenBackEnd()!=undefined && event.body.token!=undefined)
          {
            this.auth.setTokenBackEnd(event.body.token);
            this.auth.renewToken();
          }
        }
        return event;
      })
    );
  }
}